import {useMutation, useQueryClient} from '@tanstack/react-query';
import {
  restoreContentSubmissionsCache,
  updateVersionApprovalsInCache,
} from '@/utils/cache-updaters/contentSubmissions';
import raiseFlashMessage from '@/utils/raiseFlashMessage';
import translate from '@/utils/translate';
import offPlatformReviewUpdaters from '@/api/updaters/offPlatformReview';
import {CONTENT_SUBMISSION_QUERY_KEY} from '@/hooks/queries/use-content-submission-query';

function useCreateOffPlatformApprovalMutation({
  contentSubmissionId,
}: {
  contentSubmissionId: string;
}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: offPlatformReviewUpdaters.createApproval,
    onMutate: ({
      contentSubmissionId: payloadContentSubmissionId,
      contentSubmissionVersionId,
      step,
    }) => {
      const snapshots = updateVersionApprovalsInCache(
        contentSubmissionId || payloadContentSubmissionId,
        contentSubmissionVersionId,
        [step]
      );
      return {snapshots};
    },
    onSuccess: () => {
      raiseFlashMessage({
        status: 'success',
        message: translate('Approved successfully'),
      });
    },
    onError: (_err, _vars, context) => {
      if (context?.snapshots) {
        restoreContentSubmissionsCache(context.snapshots);
      }
      raiseFlashMessage({
        status: 'error',
        message: translate('Approval failed'),
      });
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [CONTENT_SUBMISSION_QUERY_KEY, contentSubmissionId],
      });
    },
  });
}

export default useCreateOffPlatformApprovalMutation;
